<template>
  <div class="payment">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">Select expert level</h4>
        <div class="text-left">
          <label for="opt1" class="radio text-left">
            <input
              type="radio"
              name="rdo"
              id="opt1"
              class="hidden"
              value="$10 - $20/hr (Junior)"
              v-model="price"
            />
            <span class="label"></span>$10 - $20/hr (Junior)
          </label>
          <br />

          <label for="opt2" class="radio text-left">
            <input
              type="radio"
              name="rdo"
              id="opt2"
              class="hidden"
              value="$15 - $40/hr (Intermediate)"
              v-model="price"
            />
            <span class="label"></span>$15 - $40/hr (Intermediate)
          </label>
          <br />

          <label for="opt3" class="radio text-left">
            <input
              type="radio"
              name="rdo"
              id="opt3"
              class="hidden"
              value="$25- $60/hr (Senior)"
              v-model="price"
            />
            <span class="label"></span>$25- $60/hr (Senior)
          </label>
          <br />

          <label for="opt4" class="radio text-left">
            <input
              type="radio"
              name="rdo"
              id="opt4"
              class="hidden"
              value="Fixed price per month"
              v-model="price"
            />
            <span class="label"></span>Fixed price per month?
          </label>
          <div class="ml-4 ml-md-5 w-50" v-show="price === 'Fixed price per month'">
            <a-input-group compact>
              <a-select v-model="budgetCurrency" default-value="USD" :disabled="disableInput">
                <a-select-option value="USD">USD</a-select-option>
                <a-select-option value="NGN">NGN</a-select-option>
                <a-select-option value="EUR">EUR</a-select-option>
              </a-select>
              <a-input style="width: 50%" v-model="budgetAmount" :disabled="disableInput" />
            </a-input-group>
          </div>
          <!-- <div class="ml-5" v-if="showInput">
                    State it:  <input type="number" class="input" placeholder="1000"/>
          </div>-->
        </div>
        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >Back</button>
            </div>
            <div class="col text-right">
              <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5">
        <span @click="skip">
          Skip
          <font-awesome-icon icon="step-forward"></font-awesome-icon>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "payment",
  data() {
    return {
      disableInput:
        this.$store.state.client.clientData.jobtype == "Crowdsource"
          ? true
          : false,
      countries: [],
      price: this.$store.state.client.clientData.price
        ? this.$store.state.client.clientData.price
        : "",
      fixedPrice: this.$store.state.client.clientData.fixedPrice
        ? this.$store.state.client.clientData.fixedPrice
        : null,
      budgetAmount: this.$store.state.client.clientData.budgetAmount
        ? this.$store.state.client.clientData.budgetAmount
        : "",
      budgetCurrency: this.$store.state.client.clientData.budgetCurrency
        ? this.$store.state.client.clientData.budgetCurrency
        : "USD",
      showInput: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { price, fixedPrice, budgetAmount, budgetCurrency } = this;
      this.$store.commit("client/updateClient", {
        price,
        fixedPrice,
        budgetAmount,
        budgetCurrency
      });
      if (this.price == "Fixed price per month") {
        this.$router.push("make-job-post");
      } else {
        this.$router.push("budget");
      }
      /*  this.$router.push("make-job-post"); */
    },
    skip() {
      this.$router.push("make-job-post");
    }
  }
};
</script>
<style scoped>
.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
